import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ApiUrl } from "../../../ApiUrl";

function StudentCircular() {
  const navigate = useNavigate();
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchCirculars = async () => {
      const studentId = sessionStorage.getItem("userId");
      const academicYearId = localStorage.getItem("academicSessionId") || "";
      const orgId = localStorage.getItem("orgId") || "";
      const branchId = localStorage.getItem("branchId") || "";

      if (!studentId) {
        setError("Student session details are missing. Please log in again.");
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError("");

        const queryParams = new URLSearchParams();
        if (academicYearId) queryParams.append("academic_year_id", academicYearId);
        if (orgId) queryParams.append("org_id", orgId);
        if (branchId) queryParams.append("branch_id", branchId);

        const response = await fetch(
          `${ApiUrl.apiurl}STUDENT_PROFILE/GetStudentCircularNotifications/${studentId}/?${queryParams.toString()}`
        );

        const contentType = response.headers.get("content-type") || "";
        const payload = contentType.includes("application/json")
          ? await response.json()
          : null;

        if (!response.ok || !payload || payload.message !== "Success") {
          throw new Error(payload?.message || "Unable to load circulars and notifications.");
        }

        setEntries(Array.isArray(payload.data) ? payload.data : []);
      } catch (fetchError) {
        console.error("Error fetching circulars and notifications:", fetchError);
        setEntries([]);
        setError(fetchError.message || "Unable to load circulars and notifications.");
      } finally {
        setLoading(false);
      }
    };

    fetchCirculars();
  }, []);

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card p-0">
            <div className="card-body">
              <p
                style={{
                  marginBottom: "0px",
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: "700",
                }}
              >
                CIRCULARS & NOTIFICATIONS
              </p>

              <div className="row mb-3 mt-3 mx-0">
                <div className="col-12 d-flex flex-wrap gap-2">
                  <button
                    type="button"
                    className="btn btn-danger me-2"
                    style={{ width: "150px" }}
                    onClick={() => navigate("/student/dashboards")}
                  >
                    Close
                  </button>
                </div>
              </div>

              <div className="col-12 container-fluid mt-4">
                {loading ? (
                  <div className="text-center py-4">Loading circulars and notifications...</div>
                ) : error ? (
                  <div className="alert alert-danger mb-0">{error}</div>
                ) : (
                  <div className="table-responsive">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Sr. No</th>
                          <th>Date</th>
                          <th>Type</th>
                          <th>Initiated By</th>
                          <th>Details</th>
                          <th>Attachment</th>
                        </tr>
                      </thead>
                      <tbody>
                        {entries.length > 0 ? (
                          entries.map((item) => (
                            <tr key={item.id}>
                              <td>{item.sr_no}</td>
                              <td>{item.date || "-"}</td>
                              <td>{item.entry_type || "-"}</td>
                              <td>{item.initiated_by || "-"}</td>
                              <td>
                                <div>{item.details || "-"}</div>
                                {item.remarks ? (
                                  <div className="text-muted mt-1">
                                    Remarks: {item.remarks}
                                  </div>
                                ) : null}
                              </td>
                              <td>
                                {item.attachment_url ? (
                                  <a
                                    href={item.attachment_url}
                                    target="_blank"
                                    rel="noreferrer"
                                  >
                                    View File
                                  </a>
                                ) : (
                                  "-"
                                )}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="6" className="text-center">
                              No circulars or notifications found for this student
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default StudentCircular;
